import { ValidatingInput, InputComponentProps } from '~/components/validating-input';
import { regexMapMeterNumber } from './utils';

export const MeterNumber = ({
  utilityId,
  ...props
}: InputComponentProps & {
  utilityId?: number;
}) => {
  const validate = ({ value }) => {
    if (value.length < 1) return 'Please enter a valid meter number';
    const [res] = regexMapMeterNumber.filter(u => utilityId === u.utilityId);
    return res.regexExpressions.some(regex => regex.test(value)) ? true : res.errorMessage;
  };

  return <ValidatingInput label="Meter number" name="meterNumber" validate={validate} {...props} />;
};
